<script setup lang="ts">
import { computed, useSlots } from 'vue';

import { AppTag } from '@libs/ui';

const slots = useSlots();

const hasActions = computed<boolean>(() => !!slots['actions']);
</script>

<template>
  <div class="unavailable-product">
    <AppTag
      class="unavailable-product-tag"
      type="warning"
      :icon="{ name: 'infoCircle', size: '13' }"
    >
      <template #title>
        <slot name="message" />
        <div v-if="hasActions" class="actions">
          <slot name="actions" />
        </div>
      </template>
    </AppTag>
  </div>
</template>

<style scoped lang="scss">
.unavailable-product {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .unavailable-product-tag {
    .actions {
      display: flex;
      align-items: flex-start;
      margin-top: var(--spacing-8);
    }
  }
}
</style>
